module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG1005-ca904cad72bfd27266e819588b5a5e7b.png";